module.exports = __webpack_public_path__ + "static/media/snowy-2.d103c77c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/snowy-2.svg
// module id = 527
// module chunks = 0